import { useState } from 'react';
import ProposalGeneratorDialog, { type ProposalPrefill } from './ProposalGeneratorDialog';
import { usePageActionFallback, type PageActionFields } from '../contexts/PageActionContext';

/**
 * THE LISTING PROPOSAL WITH NO RECORD BEHIND IT - SLICE3, his answer of 2026-10-08 (the 124th), built the 125th.
 *
 * ⭐⭐ The chat could already open the executive summary from a property or deal page; with no record on screen it
 *    answered "Nothing was opened - the executive summary dialog cannot be opened from here without a record". An owner
 *    he is pitching often has no record yet. His call: he TYPES the owner's name and mailing address - measured, the CRM
 *    `contacts` table has no address column and `owner_research` holds no rows, so there is nothing to prefill from.
 *
 * ⭐ IT TAKES NOTHING AWAY, the same argument as `RecordlessLoiHost`: every prop of `ProposalGeneratorDialog` but `open`
 *   is optional, and `POST /api/proposals/generate` without a `deal_id` builds only (`buildProposalOnly`: nothing written,
 *   "Not filed anywhere - download the Word file to keep it.").
 *
 * ⛔⛔ Nothing in this file may ever grow a `dealId`, `propertyId` or `onFiled` - a recordless proposal has no target, so
 *    there is nothing to aim at the wrong building.
 * ⚠️ MOUNTED BY `Layout`, NEVER BY `AiRail`: the rail renders nothing while collapsed, so a host inside it would
 *   deregister when he closed the panel and the action would refuse for a reason invisible from the screen.
 */
export default function RecordlessProposalHost() {
  const [open, setOpen] = useState(false);
  const [prefill, setPrefill] = useState<ProposalPrefill>({});

  usePageActionFallback('open_listing_proposal_dialog', (fields: PageActionFields) => {
    // ⭐ The field names already match `ProposalPrefill`; only what he STATED arrives (appAssistantActions filters the rest).
    setPrefill(fields as ProposalPrefill);
    setOpen(true);
  });

  return <ProposalGeneratorDialog open={open} onClose={() => setOpen(false)} prefill={prefill} />;
}
